import { Box, Container, Paper, Title, Text, Button, Flex, ThemeIcon } from "@mantine/core";
import { IconCircleCheck } from "@tabler/icons-react";
import { useNavigate, useLocation } from "react-router-dom";

interface RegistrationData {
  companyName: string;
  location: string;
  email: string;
}

export default function RegistrationSuccessPage() {
  const navigate = useNavigate();
  const location = useLocation();

  // Get data from navigation state
  const registrationData: RegistrationData = location.state || {
    companyName: "-",
    location: "-",
    email: "-",
  };

  const handleProceed = () => {
    navigate("/login");
  };

  return (
    <Box mih="100vh" py={40}>
      <Container size="lg">
        {/* Header */}
        <Flex direction="column" align="center" gap={4} mb="xl">
          <Title order={1} fz={{ base: 24, sm: 28 }} fw={600} c="#2563EB">
            GT Setu
          </Title>
          <Text fz={{ base: "sm", sm: "md" }} c="#2563EB" fw={500}>
            A Global Trade Sphere Initiative
          </Text>
        </Flex>

        {/* Success Card */}
        <Paper
          shadow="sm"
          p={{ base: "lg", sm: "xl" }}
          radius="lg"
          maw={650}
          mx="auto"
          style={{ border: "1px solid #E5E7EB" }}
        >
          {/* Success Icon */}
          <Flex justify="center" mb="lg">
            <ThemeIcon
              size={60}
              radius="xl"
              color="teal"
              variant="light"
              styles={{
                root: {
                  backgroundColor: "#D1FAE5",
                },
              }}
            >
              <IconCircleCheck size={36} color="#10B981" />
            </ThemeIcon>
          </Flex>

          {/* Success Title */}
          <Title order={2} fz={{ base: 18, sm: 20 }} ta="center" mb="sm">
            Registration Successful!
          </Title>

          {/* Success Description */}
          <Text fz={{ base: "xs", sm: "sm" }} c="slate.6" ta="center" mb="xl">
            Your account has been created successfully. Please verify your email to access the platform and start
            building your company profile.
          </Text>

          {/* Registration Summary Box */}
          <Box bg="#F9FAFB" p="md" mb="xl" style={{ border: "1px solid #E5E7EB" }}>
            <Text fz="sm" fw={600} mb="md">
              Registration Summary
            </Text>

            <Flex direction="column" gap="xs">
              <Flex justify="space-between" align="center">
                <Text fz="sm" c="slate.6">
                  Company Name:
                </Text>
                <Text fz="sm" fw={500}>
                  {registrationData.companyName}
                </Text>
              </Flex>

              <Flex justify="space-between" align="center">
                <Text fz="sm" c="slate.6">
                  Location:
                </Text>
                <Text fz="sm" fw={500}>
                  {registrationData.location}
                </Text>
              </Flex>

              <Flex justify="space-between" align="center">
                <Text fz="sm" c="slate.6">
                  Email:
                </Text>
                <Text fz="sm" fw={500}>
                  {registrationData.email}
                </Text>
              </Flex>
            </Flex>
          </Box>

          {/* Proceed Button */}
          <Flex justify="center">
            <Button
              size="md"
              px="xl"
              w="100%"
              maw={200}
              onClick={handleProceed}
              styles={{
                root: {
                  backgroundColor: "#2563EB",
                  "&:hover": {
                    backgroundColor: "#1D4ED8",
                  },
                },
              }}
            >
              Go to Login
            </Button>
          </Flex>
        </Paper>
      </Container>
    </Box>
  );
}
